import React from "react";
import styled from "styled-components";

import { ProductsGridSkeletonLoggedOut } from "@faire/retailer/views/brand/ProductsGridSkeleton/ProductsGridSkeletonLoggedOut";

export const LoadingProductTile: React.FC<{ isMobile?: boolean }> = ({
  isMobile,
}) => {
  const dataTestId = isMobile
    ? "brand-info-page-loader-skeleton-mobile"
    : "brand-info-page-loader-skeleton";

  return (
    <PageLoaderContainer data-test-id={dataTestId}>
      <ProductsGridSkeletonLoggedOut />
    </PageLoaderContainer>
  );
};

const PageLoaderContainer = styled.div`
  min-height: 200px;
  width: 100%;
  position: relative;
  flex: 1;
`;
